module.exports = __webpack_public_path__ + "static/media/loader.bc2ac9ec.png";